<template>
    <el-dialog title="确认退出实操环境" :visible.sync="visible" width="750px" :close-on-click-modal="false" :close-on-press-escape="false">
        <p style="margin-top: 20px">您即将退出当前实操环境，环境一旦关闭，所有非保存在data目录下的操作内容将不可恢复。请确保您已保存所有重要数据，以免造成不必要的损失。</p>
        <template else>
            <p style="margin-top: 20px">请选择退出选项：</p>
            <ul>
                <li :class="selected?'selected':''" @click="changeSelected(true)">
                    <h5>一键提交当前操作结果</h5>
                    <span class="tip">若选择此选项，系统将在退出前自动为您提交当前环境中的所有操作结果和日志作为最终提交。请注意，这将覆盖您之前的任何提交记录。</span>
                </li>
                <li :class="!selected?'selected':''" @click="changeSelected(false)">
                    <h5>以最近一次提交为准</h5>
                    <span style="display:block;" v-if="commitDate">{{commitDate}}</span>
                    <span style="display:block" class="record" v-else>暂无提交记录</span>
                    <span class="tip">保持最后一次提交的结果和日志不变，直接退出环境，不执行新的提交。</span>
                </li>
            </ul>
        </template>
        <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="signOut">确定退出</el-button>
            </span>
    </el-dialog>
</template>

<script>

import { getLastDate} from "@/api/training";
export default {
    name: "startConfirmDialog",
    data() {
        return {
            visible: false,
            id: null,
            selected: true,
            commitDate: null
        }
    },
    methods: {
        open(id) {
            this.visible = true
            this.id = id
            this.getResult()
        },
        cancel() {
            this.visible = false
            this.commitDate = null
        },
        signOut() {
            this.visible = false
            if (this.selected) {
                this.$emit('commitAndSignOut')
            } else {
                this.$emit('signOut')
            }
        },
        changeSelected (selected) {
            this.selected = selected
        },
        getResult() {
            let _this =this
            if (this.$route.query.exam) {
                getLastDate(_this.id, {
                    questionId: parseInt(_this.$route.query.examPaperQuestionId),
                    questionCrossheadIndex: null
                }).then((res) => {
                    this.commitDate = res.data ? res.data : null
                })
            }
        }
    }
}
</script>

<style scoped>
p {
    line-height: 22px;
}

ul {
    display: flex;
    padding-left: 0;
    flex-wrap: wrap;
    max-height: 438px;
    overflow-y: auto;
}
ul li {
    list-style: none;
    box-sizing: border-box;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    padding: 6px 20px;
    margin-right: 20px;
    margin-bottom: 12px;
    width: 345px;
    height: 150px;
    color: #000;
    cursor: pointer;
    line-height: 16px;
    padding: 15px;
    background: #fff;
}
ul li:nth-child(2n) {
    margin-right: 0px;
}

ul li > h5 {
    font-size: 20px;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    line-height: 35px;
    margin-bottom: 10px;
}
ul li > p {
    margin: 0 0 4px;
}

ul li.selected {
    border-color: #99c6f2;
    position: relative;
    color:#99c6f2
}
ul li span{
    line-height: 20px;
}
ul li .selected-icon {
    display: none;
}
ul li.selected .selected-icon {
    display: block;
    position: absolute;
    top: 1px;
    right: 0;
    color: #fff;
    z-index: 111;
}
ul li.selected:after {
    content: '';
    display: block;
    top: 0;
    right: 0;
    background: #99c6f2;
    position: absolute;
    width: 30px;
    height: 30px;
    clip-path: polygon(0 0, 30px 0, 30px 30px);
}
.record {
    color:#fd3d3d
}
.tip{
   color:#898989
}
</style>
